import { Features } from '@common/common.constant';

export const CATALOGUE_TABS = [
    {
        name: Features.products,
        templateRef: 'productTabContentRef',
        defaultSecondaryTab: 'Images',
        sortOrder:0,
        disabled:false
    },
    {
        name: Features.investors,
        templateRef: 'investorTabContentRef',
        defaultSecondaryTab: 'Upload',
        sortOrder:1,
        disabled:false
    },
    {
        name: Features.partners,
        templateRef: 'partnersTabContentRef',
        defaultSecondaryTab: 'Upload',
        sortOrder:2,
        disabled:false
    },
    {
        name: Features.downloads,
        templateRef: 'downloadsTabContentRef',
        defaultSecondaryTab: 'Upload',
        sortOrder:3,
        disabled:false
    },
    {
        name: Features.nfo,
        templateRef: 'nfoTabContentRef',
        defaultSecondaryTab: 'Images',
        sortOrder:4,
        disabled:false
    },
    {
        name: Features.ceoDesk,
        templateRef: 'ceoDeskTabContentRef',
        defaultSecondaryTab: 'Upload',
        sortOrder:5,
        disabled:false
    },
    {
        name: Features.latestNews,
        templateRef: 'latestNewsTabContentRef',
        defaultSecondaryTab: 'Upload',
        sortOrder:6,
        disabled:false
    },
    {
        name: Features.media,
        templateRef: 'mediaTabContentRef',
        defaultSecondaryTab: 'Upload',
        sortOrder:7,
        disabled:false
    },
    {
        name: Features.careers,
        templateRef: 'careersTabContentRef',
        defaultSecondaryTab: 'Careers',
        sortOrder:8,
        disabled:false
    },
    {
        name: Features.contactUs,
        templateRef: 'contactUsTabContentRef',
        defaultSecondaryTab: 'Excel',
        sortOrder:9,
        disabled:false
    },
    {
        name: Features.userData,
        templateRef: 'userDataTabContentRef',
        defaultSecondaryTab: null,
        sortOrder:10,
        disabled:false
    },
    {
        name: Features.relationshipManager,
        templateRef: 'relationshipManagerTabContentRef',
        defaultSecondaryTab: 'Excel',
        sortOrder:11,
        disabled:false
    },
    {
        name: Features.navDividends,
        templateRef: 'navDividendsTabContentRef',
        defaultSecondaryTab: 'NavDividends',
        sortOrder:12,
        disabled:false
    },
    {
        name: Features.advertisement,
        templateRef: 'advertisementTabContentRef',
        defaultSecondaryTab: 'Upload',
        sortOrder:13,
        disabled:false
    },
    {
        name: Features.expenseRatio,
        templateRef: 'expenseRatioTabContentRef',
        defaultSecondaryTab: 'Upload',
        sortOrder:14,
        disabled:false
    },
    {
        name: Features.digitalFactsheet,
        templateRef: 'digitalFactsheetTabContentRef',
        defaultSecondaryTab: 'digitalFactsheet',
        sortOrder:15,
        disabled:false
    },
    {
        name: Features.aboutUs,
        templateRef: 'aboutUsTabContentRef',
        defaultSecondaryTab:'Upload',
        sortOrder:16,
        disabled:false
    },
    {
        name: Features.IAPpage,
        templateRef: 'iapPageTabContentRef',
        defaultSecondaryTab:'Upload',
        sortOrder:16,
        disabled:false
    }
]


export class CatalogueTab {
    name:string;
    templateRef:string;
    sortOrder: number;
    defaultSecondaryTab?:string
    disabled: boolean;
}
